import React, { useEffect, useRef, useState } from 'react';
import '../../../Styles/sliderable.css';
import leftSVG from "../../../images/left.svg";
import rightSVG from "../../../images/right.svg";
import viewAll from "../../../images/viewAll.png";
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import femaleImg from "../../../images/femaleMatch.png";
import maleImg from "../../../images/maleMatch.png";
import { Skeleton, Box, Button } from '@mui/material'; // Import MUI components

export const SliderComponent = ({ data, title, matchesType, onViewAllClick, onProfileClick }) => {
    const slideRef = useRef(null);
    const btnLeftRef = useRef(null);
    const btnRightRef = useRef(null);
    const navigate = useNavigate();
    const gender = localStorage.getItem('gender');
    const defaultImage = gender === 'F' ? maleImg : femaleImg;

    const [loading, setLoading] = useState(true); // Add a loading state

    useEffect(() => {
        // Simulate a delay for loading (if needed)
        const timer = setTimeout(() => {
            setLoading(false); // Set loading to false after 2 seconds (or after data is fetched)
        }, 2000); // Adjust the delay time if necessary

        return () => clearTimeout(timer);
    }, [data]);

    const handleClick = (direction) => {
        if (slideRef.current) {
            const slideInner = slideRef.current.querySelector('.Sliderable-inner');
            const itemWidth = slideInner.firstChild.offsetWidth;
            const currentTransform = slideInner.style.transform;
            const currentPosition = currentTransform ? parseFloat(currentTransform.match(/-?\d+/)[0]) : 0;

            if (direction === 'left') {
                slideInner.style.transform = `translateX(${Math.min(0, currentPosition + itemWidth)}px)`;
            } else {
                slideInner.style.transform = `translateX(${Math.max(-slideInner.scrollWidth + slideRef.current.clientWidth, currentPosition - itemWidth)}px)`;
            }
        }
    };

    useEffect(() => {
        const slider = slideRef.current;
        if (slider) {
            const slideInner = slider.querySelector('.Sliderable-inner');
            slider.style.width = `${slideInner.scrollWidth}px`;

            const handleResize = () => {
                slider.style.width = `${slideInner.scrollWidth}px`;
            };

            window.addEventListener('resize', handleResize);
            return () => window.removeEventListener('resize', handleResize);
        }
    }, [data, title]);

    const handleSearch = async (profileId) => {
        try {
            navigate('/profile-view', { state: { user_id: profileId } });
        } catch (error) {
            toast.error('Something Went Wrong:', error);
        }
    };

    const handleTouchStart = (e) => {
        if (window.innerWidth <= 768) { // Only activate touch scroll for mobile views
            const touchStartX = e.touches[0].clientX;
            slideRef.current.setAttribute('data-touch-start', touchStartX);
        }
    };

    const handleTouchMove = (e) => {
        if (window.innerWidth <= 768) { // Only activate touch scroll for mobile views
            const touchStartX = parseFloat(slideRef.current.getAttribute('data-touch-start'));
            const touchMoveX = e.touches[0].clientX;
            const deltaX = touchMoveX - touchStartX;

            // Move the slider if swipe distance is sufficient
            if (Math.abs(deltaX) > 50) {
                const direction = deltaX > 0 ? 'left' : 'right';
                handleClick(direction);
                slideRef.current.removeAttribute('data-touch-start'); // Reset touch position
            }
        }
    };

    useEffect(() => {
        const slider = slideRef.current;

        if (slider) {
            slider.addEventListener('touchstart', handleTouchStart);
            slider.addEventListener('touchmove', handleTouchMove, { passive: false }); // Prevent default behavior to avoid scrolling

            return () => {
                slider.removeEventListener('touchstart', handleTouchStart);
                slider.removeEventListener('touchmove', handleTouchMove);
            };
        }
    }, []);

    return (
        <div className="basicDetailTlt">
            <p className='text-left'>
                {title === 'Who Looking For Me'
                    ? 'Looking For Me'
                    : title === 'Premium'
                        ? 'Premium Matches'
                        : title}{' '}
                <span>({data.length})</span>
            </p>

            {loading ? (
                <div className="row">
                    <div className="Sliderable" ref={slideRef}>
                        <div className="Sliderable-inner">
                            {[...Array(4)].map((_, index) => ( // Create skeletons for the items
                                <div className="item" key={index}>
                                    <div className="itemContent">
                                        <Skeleton variant="rectangular" width="100%" height={120} sx={{ backgroundColor: '#e0e0e0' }} />
                                        <Skeleton variant="text" width="60%" sx={{ backgroundColor: '#e0e0e0', marginTop: 10 }} />
                                        <Skeleton variant="text" width="40%" sx={{ backgroundColor: '#e0e0e0', marginTop: 5 }} />
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            ) : (
                data.length > 0 ? (
                    <div className="row">
                        <div className="Sliderable" ref={slideRef}>
                            <div className="Sliderable-inner">
                                {data.map((item, index) => (
                                    <div className="item" key={index} onClick={() => onProfileClick(item.username)}>
                                        <div className="itemContent">
                                            <a href="">
                                                <img src={item.photo ? item.photo : defaultImage} className="itemImage" />
                                                <div className="overlay">
                                                    <p><b>{item.name}</b></p>
                                                    <p>{item.age} year - {item.city}</p>
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                ))}
                                {data.length > 4 && (
                                    <div className="item" key="view-all" onClick={() => onViewAllClick(matchesType)}>
                                        <div className="itemContent">
                                            <a href="#">
                                                <img src={viewAll} alt="View All" className="itemImage" />
                                                <div className="overlay">
                                                    <p><b>View All</b></p>
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                )}
                            </div>

                            {data.length > 3 && (
                                <>
                                    <button className="btn btn-light btn-left" onClick={() => handleClick('left')} ref={btnLeftRef}>
                                        <img src={leftSVG} width="15px" alt="left" />
                                    </button>
                                    <button className="btn btn-light btn-right" onClick={() => handleClick('right')} ref={btnRightRef}>
                                        <img src={rightSVG} width="15px" alt="right" />
                                    </button>
                                </>
                            )}
                        </div>
                    </div>
                ) : (
                    <p>No Data Available</p>
                )
            )}
        </div>
    );
};
